/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbAdjointGridDto } from './FcbAdjointGridDto';
import {
    FcbAdjointGridDtoFromJSON,
    FcbAdjointGridDtoFromJSONTyped,
    FcbAdjointGridDtoToJSON,
} from './FcbAdjointGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbAdjointGridDtoPaginatedResults
 */
export interface FcbAdjointGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbAdjointGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbAdjointGridDto>}
     * @memberof FcbAdjointGridDtoPaginatedResults
     */
    results?: Array<FcbAdjointGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbAdjointGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbAdjointGridDtoPaginatedResults interface.
 */
export function instanceOfFcbAdjointGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAdjointGridDtoPaginatedResultsFromJSON(json: any): FcbAdjointGridDtoPaginatedResults {
    return FcbAdjointGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbAdjointGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAdjointGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbAdjointGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbAdjointGridDtoPaginatedResultsToJSON(value?: FcbAdjointGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbAdjointGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

